import { gql, useMutation } from "@apollo/client";

import { normalizeErrors } from "../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../types/NormalizedErrorMap";
import { PushSubscriptionProvider } from "../constants";

interface RegisterPushSubscriptionInput {
  provider: PushSubscriptionProvider;
  token: string;
  platform?: string;
  deviceId?: string;
}

interface RegisterPushSubscriptionMutation {
  registerPushSubscription: {
    errors: Array<{ path: string; message: string }> | null;
    message: string | null;
  };
}

interface RegisterPushSubscriptionVariables {
  input: RegisterPushSubscriptionInput;
}

export const registerPushSubscriptionMutation = gql`
  mutation RegisterPushSubscriptionMutation($input: RegisterPushSubscriptionInput!) {
    registerPushSubscription(input: $input) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export function useRegisterPushSubscription() {
  const [mutate, { loading, error, data }] = useMutation<
    RegisterPushSubscriptionMutation,
    RegisterPushSubscriptionVariables
  >(registerPushSubscriptionMutation);

  const registerPushSubscription = async (input: RegisterPushSubscriptionInput) => {
    const { data: mutationData } = await mutate({ variables: { input } });
    const result = mutationData?.registerPushSubscription;
    const errors = result?.errors ? normalizeErrors(result.errors) : null;

    return {
      errors: errors as NormalizedErrorMap | null,
      message: result?.message ?? undefined,
    };
  };

  return {
    registerPushSubscription,
    loading,
    error,
    message: data?.registerPushSubscription?.message || null,
  };
}